const soundEnumerators = {
  type: [
    'Sound Only',
    'Sound with Nature',
    'Sound with Music',
  ],
};

export default soundEnumerators;
